import {
  DownloadOutlined,
  LoadingOutlined,
  LogoutOutlined,
  MenuOutlined,
  QuestionCircleOutlined,
  SearchOutlined,
  SettingOutlined,
  TableOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Dropdown,
  MenuProps,
  Modal,
  Spin,
  TreeSelect,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SafeLink from "../../components/link/SafeLink";
import MyNotificationDrop from "../../components/my-notifycation-drop";
import { routesConfig } from "../../config/routes";
import { useViewport } from "../../hooks/useViewport";
import { getDetailAdminInterface } from "../../service/admin-interface";
import { globalStore, useAuthStore } from "../../stores/stores";
import { getContrastingColor } from "../../utils/functionUltils";
import { exportCourseInfo, postLogout } from "./services";
import { IS_QTHT } from "../../constants";
import "./header.scss";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/language-switcher/LanguageSwitcher";
import { isEmpty } from "lodash";

export type HeaderLayoutProps = {
  activeMenu: () => void;
};
interface DataNode {
  uuid: string;
  name: string;
  canManage: boolean;
  children: DataNode[];
  logo: string
}

const HeaderLayout = (props: HeaderLayoutProps) => {
  const { t } = useTranslation();
  const logout = useAuthStore((state) => state.logout);

  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [color, setColor] = useState<any>({});
  const [logoPersonal, setLogoPersonal] = useState<any>("");
  const [backgroundColor, setBackgroundColor] = useState<any>({});
  const [logo, setLogo] = useState<any>("");
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [value, setValue] = useState<string | undefined>("");

  const navigate = useNavigate();
  const { reloadAdminInterface, personalInfo, setReload, reload } = globalStore();
  const location = useLocation();
  const pathname = location.pathname;
  const { width } = useViewport();

  useEffect(() => {
    if (width <= 1200) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);

  useEffect(() => {
    getColor();
  }, [navigate, reloadAdminInterface, personalInfo]);

  useEffect(() => {
    getColorDetail();
  }, [navigate, reloadAdminInterface]);

  const logoutFNC = async () => {
    await postLogout().then((res) => {
      if (res.status === 200) {
        logout();
        setTimeout(() => {
          navigate(routesConfig.login);
          setLoading(false);
        }, 1000);
      }
    });
  };

  const getColor = async () => {
    setColor(personalInfo?.color);
    setLogoPersonal(personalInfo?.logo);
  };

  const getColorDetail = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id: any = urlParams.get("interfaceId");
    if (id) {
      await getDetailAdminInterface(id).then((res) => {
        if (res.status === 200) {
          setBackgroundColor(res.data?.data?.color?.backgroundColor);
          setLogo(res.data?.data?.logo);
        }
      });
    }
  };

  const { getUserInfo } = useAuthStore((state) => {
    return {
      getUserInfo: state.user,
    };
  });

  const handleLogout = async () => {
    setLoading(true);
    try {
      logoutFNC();
      localStorage.setItem("schoolManagement", "")

    } catch (error) {
      logout();
      setLoading(false);
    }
  };

  const { confirm } = Modal;

  const showConfirm = () => {
    confirm({
      title: (
        <div className="title-container">
          <div style={{ color: "#1677FF", fontSize: "20px" }}>
            <LogoutOutlined />
          </div>
          <span>{t("header.logoutConfirmTitle", "Xác nhận đăng xuất?")}</span>
        </div>
      ),
      //   centered: true,
      icon: null,
      okText: t("header.logout", "Đăng xuất"),
      cancelText: t("common.cancel", "Hủy"),
      onOk() {
        handleLogout();
      },
      onCancel() { },
    });
  };

  const items: MenuProps["items"] = [
    {
      key: "0",
      label: (
        <div className="account account-drop">
          <div className="account__avatar">
            <div className="account__avatar__wrapper">
              <a onClick={(e) => e.preventDefault()}>
                <Avatar src={getUserInfo?.anhDaiDien} icon={<UserOutlined />} />{" "}
              </a>
            </div>
          </div>
          <div className="account__name">
            <a
              className="account__name__wrapper"
              onClick={(e) => e.preventDefault()}
            >
              <span>{getUserInfo?.hoVaTen}</span>
              <span className="email">{getUserInfo?.email}</span>
            </a>
          </div>
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <SafeLink
          className="account__menu__item"
          rel="account"
          to={routesConfig.userInfo}
        >
          <UserOutlined />
          <span>{t("header.personalInfo", "Thông tin cá nhân")}</span>
        </SafeLink>
      ),
    },
    {
      key: "3",
      label: (
        <a className="account__menu__item" rel="settings">
          <SettingOutlined />
          <span>{t("header.accountSettings", "Cài đặt")}</span>
        </a>
      ),
    },
    {
      key: "4",
      label: (
        <a className="account__menu__item border-bottom" rel="helper">
          <QuestionCircleOutlined />
          <span>{t("header.help", "Trợ giúp")}</span>
        </a>
      ),
    },
    {
      key: "5",
      label: (
        <a className="account__menu__item" rel="log-out" onClick={showConfirm}>
          <LogoutOutlined />
          <span>{t("header.logout", "Đăng xuất")}</span>
        </a>
      ),
    },
  ];

  const contrastingTextColor = getContrastingColor(color?.menuColor);

  const generateTreeData = (nodes: DataNode[]): any[] =>
    nodes?.map((node) => ({
      title: <div> <Avatar shape="square" size="small" src={node?.logo} /> {node.name}</div>,
      value: node.uuid,
      disabled: !node.canManage,
      children: generateTreeData(node.children),
    }));

  const findFirstManagedUuid = (nodes: DataNode[]): string | null => {
    for (const node of nodes) {
      if (node.canManage) {
        return node.uuid;
      }
      if (node.children?.length > 0) {
        const found = findFirstManagedUuid(node.children);
        if (found) return found;
      }
    }
    return null;
  };

  const getAllUuids = (nodes: DataNode[]): string[] => {
    let uuids: string[] = [];
    nodes.forEach((node) => {
      uuids.push(node.uuid);
      if (node.children?.length > 0) {
        uuids = uuids.concat(getAllUuids(node.children));
      }
    });
    return uuids;
  };
  
  const handleExportCourseInfo = async () => {
    try {
      setExportLoading(true);
      const res = await exportCourseInfo();
      if(res.status === 200) {
        const fileData = res.data;

        const blob = new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);

        downloadLink.download = "Thông tin các khóa học";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        setExportLoading(false);
      }
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    } finally {
      setExportLoading(false);
    }
  }

  useEffect(() => {
    const schoolManagement = localStorage.getItem("schoolManagement");
    const validUuids = getAllUuids(personalInfo?.managedEnterprises || []);

    if (schoolManagement && validUuids.includes(schoolManagement)) {
      setValue(schoolManagement);
      return;
    }

    if (personalInfo?.managedEnterprises?.length > 0) {
      const firstManagedUuid = findFirstManagedUuid(personalInfo.managedEnterprises);
      if (firstManagedUuid) {
        localStorage.setItem("schoolManagement", firstManagedUuid);
        setValue(firstManagedUuid);
      } else {
        setValue(personalInfo?.managedEnterprises?.[0]?.uuid || "");
      }
    }
  }, [personalInfo?.managedEnterprises]);


  return (
    <>
      <div className="global-header">
        <div
          className="global-header1"
          style={{
            background: `${pathname.includes(routesConfig.detailAdminInterface)
              ? backgroundColor
              : color
                ? color?.backgroundColor
                : "#9F224E"
              }`,
            color: contrastingTextColor,
          }}
        >
          {isMobile ? (
            <Button className="btn-mobile" onClick={props.activeMenu}>
              <MenuOutlined />
            </Button>
          ) : null}
          <div
            className="logo-mooc2 cursor-pointer"
            onClick={() => navigate("/")}
          >
            {logo || logoPersonal ? (
              <img
                src={
                  pathname.includes(routesConfig.detailAdminInterface)
                    ? logo
                    : logoPersonal
                }
                className="w-8 h-8 rounded-lg object-cover"
                alt="logo-mooc"
              />
            ) : (
              <div className="shape2" />
            )}
            <h2 className="mooc2">
              {process.env.REACT_APP_PROJECT_NAME || ""}
            </h2>
          </div>
          <div className="menulegacy flex">
            <ul>
              <li>
                <Link to={"#"} className="active-link--menu">
                  <TableOutlined
                    style={{
                      color: contrastingTextColor,
                    }}
                  />
                  <Typography.Text
                    style={{
                      color: contrastingTextColor,
                      textAlign: "center",
                    }}
                  >

                    {t("header.management", "Quản lý")}
                  </Typography.Text>
                </Link>
              </li>
              
            </ul>
            {personalInfo?.managedEnterprises?.length > 0 &&
              <TreeSelect
                style={{ maxWidth: '560px', minWidth: '460px' }}
                value={value}
                dropdownStyle={{ maxHeight: 500, overflow: 'auto' }}
                treeData={generateTreeData(personalInfo?.managedEnterprises)}
                placeholder="Please select"
                treeDefaultExpandAll
                onChange={(newValue) => {
                  setValue(newValue);
                  localStorage.setItem("schoolManagement", newValue);
                  setReload(!reload);
                }}
              />}
          </div>
          <div className="toolbar">
            {personalInfo?.role === IS_QTHT &&
              <div className="icon-wrapper">
                {exportLoading ? (
                  <LoadingOutlined />
                ) : (
                  <a
                    href="#"
                    title={t("Tải về thông tin khóa học", "Tải về thông tin khóa học")}
                    onClick={handleExportCourseInfo}
                  >
                    <DownloadOutlined
                      style={{
                        color: contrastingTextColor,
                        fontSize: "14px",
                      }}
                    />
                  </a>
                )}
              </div>
            }
            <div className="icon-wrapper">
              <a href="#">
                <SearchOutlined
                  style={{
                    color: contrastingTextColor,
                    fontSize: "14px",
                  }}
                />
              </a>
            </div>
            <div className="icon-wrapper">
              <a href="#">
                <QuestionCircleOutlined
                  style={{
                    color: contrastingTextColor,
                    fontSize: "14px",
                  }}
                />
              </a>
            </div>
            <div className="icon-wrapper">
              <LanguageSwitcher contrastingTextColor={contrastingTextColor} />
            </div>
            <MyNotificationDrop />
            <Dropdown
              overlayClassName="header-account"
              trigger={["click"]}
              menu={{ items }}
            >
              <div className="account">
                <div className="account__avatar">
                  <div className="account__avatar__wrapper">
                    <a onClick={(e) => e.preventDefault()}>
                      <Avatar
                        src={getUserInfo?.anhDaiDien}
                        icon={<UserOutlined />}
                      />
                    </a>
                  </div>
                </div>
                <div className="account__name">
                  <a
                    className="account__name__wrapper"
                    onClick={(e) => e.preventDefault()}
                  >
                    <div
                      style={{
                        color: contrastingTextColor,
                      }}
                    >
                      {getUserInfo?.hoVaTen}
                    </div>
                  </a>
                </div>
              </div>
            </Dropdown>
          </div>
        </div>
        <Spin spinning={loading} fullscreen size="large" />
      </div>
    </>
  );
};

export default HeaderLayout;
